import { css } from "lit"

export default css`
:host {
    display: block;
    min-width: var(--fp-login-form-min-width, 25em);
    max-width: 100vw;
}

@media (max-width: 48em) {
    :host {
        font-size: var(--fp-font-size-base, 1em);
        max-width: 100%;
        min-width: 100%;
    }
}

.hidden {
    display: none;
}

.default-screen {
    display: none;
}

.show-default-screen {
    display: block;
}

.logo img {
    max-width: 80px;
    max-height: 80px;
}

.flow-container {
    --pu-color-box-background: transparent;
    --pu-border-button-corner-radius: var(--pu-border-radius-200, 8px);
    width: 100%;
}

.form {
    --pu-color-input-placeholder-text: rgb(from var(--fp-input-placeholder-text-color, rgb(136, 136, 136)) r g b / alpha);
    --pu-color-input-text: rgb(from var(--fp-input-text-color, rgb(47, 47, 47)) r g b / alpha);
    --pu-color-input-text-hover: rgb(from var(--fp-input-text-color-hover, rgb(0, 0, 0)) r g b / alpha);
    --fp-login-input-gap: 0.5em;
    width: 100%;
}

.login-email-layout::part(base) {
    --pu-space-grid-vertical-wide: var(--fp-login-form-spacing, 0.25em);
    --pu-space-grid-vertical-narrow: var(--fp-login-form-spacing, 0.25em);
}

.button::part(button) { 
    --pu-border-button-corner-radius: var(--fp-button-corner-radius, var(--pu-border-radius-200, 0.5em));
    --pu-border-button-width: var(--fp-button-border-width, 0.0625em);
    --pu-color-button-border: rgb(from var(--fp-button-border-color, var(--fp-button-background-color)) r g b / alpha);
    --pu-color-button-outline: rgb(from var(--fp-button-outline-color, var(--fp-button-background-color)) r g b / alpha);
    --pu-size-button-height: var(--fp-button-height, 3.5em);
}

.email-input {
    width: 100%;
}

.email-input::part(base) {
    --pu-color-input-text: var(--fp-input-text-color);
    --pu-color-input-text-hover: var(--fp-input-text-color-hover);
    --pu-color-input-background: var(--fp-input-background-color);
    --pu-color-focus-ring-background: var(--fp-input-background-color);
    --pu-color-input-border: var(--fp-input-border-color);
    --pu-border-input-width: var(--fp-input-border-width);
    --pu-border-input-corner-radius: var(--fp-input-corner-radius, var(--pu-border-radius-200, 8px));
    --pu-space-input-padding: var(--fp-input-padding, 1em);
    text-align: center;
    font-family: var(--fp-body-font);
}

.email-input::part(input)::placeholder {
    font-family: var(--fp-body-font);
}

.email-error {
    --pu-color-base-text: rgb(255, 0, 0);
}

.otp-code-input::part(base) {
    --pu-color-input-text: var(--fp-input-text-color);
    --pu-color-input-text-hover: var(--fp-input-text-color-hover);
    --pu-color-input-background: var(--fp-input-background-color);
    --pu-color-focus-ring-background: var(--fp-input-background-color);
    --pu-color-input-border: var(--fp-input-border-color);
    --pu-border-input-width: var(--fp-input-border-width);
    --pu-border-input-corner-radius: var(--pu-border-radius-300, 0.75em);
    --pu-space-input-padding: var(--fp-input-padding, 1em);
}
.otp-code-input::part(control) {
    max-width: 40px;
    text-align: center;
    padding: 0;
}

.otp-code-input.otp-code-error::part(input) {
    border-color: rgb(255, 0, 0);
}

.otp-code-error {
    --pu-color-base-text: rgb(255, 0, 0);
}

.resend-otp-code-button {
    --pu-size-button-height: 0.75em;
}

.loading__spinner {
    animation-name: spin;
    animation-duration: 500ms;
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-iteration-count: infinite;
    fill: currentcolor;
    color: var(--pu-color-base-text, rgb(160, 160, 160));
    height: 3em;
    width: 3em;
    left: 50%;
    top: 50%;
    margin: calc(var(--pu-space-400, 1em) / 2 * -1) 0 0
        calc(var(--pu-space-400, 1em) / 2 * -1);
}
@keyframes spin {
    to {
        transform: rotate(1turn);
    }
}
`
